import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Section } from '../../Tool-kit/Section'
import DomainSquare from './DomainsSquare'
import CallToAction from '../../container/CallToAction'
import Text from '../../Tool-kit/Typography'
import { readingTime, convertDate } from 'utils/articles'
import Flex from '../../Tool-kit/Flex'
import TimeLapse from '../../assests/icons/TimeLapseIcon'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import { useMediaQuery } from '@mui/material'
import { useFetchPage } from 'hooks/useFetchPage'
import { useLocale } from 'hooks/useLocale'
import QueryWrapper from 'container/querywrapper'
import ArticleImage from '../../assests/images/ArticleImage.png'

import { useParams } from 'react-router'
import ReactMarkdown from 'react-markdown'

const { REACT_APP_STRAPI_API_URL } = process.env

const Wrapper = styled(Section)``

const ArticleHeader = styled.div`
  padding: 0rem 8rem;
  margin: 4rem 7rem;
  background: #f1bc11;
  padding-top: 4rem;
  padding-bottom: 2rem;
  border-radius: 6px;
  > * {
    flex: 1;
  }

  .article-image {
    max-width: 100%;
  }

  @media ${devices.tabport} {
    padding: 4rem;
    margin: 4rem 0rem;
  }
  @media ${devices.phone} {
    margin: 4rem 0rem;
    padding: 4rem 2rem;
  }
`

const ArticleContent = styled.div`
  max-width: 75%;
  margin: 0px auto;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 20px;
  font-family: Roboto;
  margin-bottom: 141px;
  @media ${devices.tabport} {
    max-width: 90%;
  }
  .image-wrapper {
    position: relative;
    padding-top: 50.25%;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  li {
    margin-top: 10px;
  }

  h1 {
    margin-top: 0.67em;
    margin-bottom: 0.67em;
  }
  h2 {
    margin-top: 0.83em;
    margin-bottom: 0.83em;
  }
  h3 {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  h4 {
    margin-top: 1.33em;
    margin-bottom: 1.33em;
  }
  h5 {
    margin-top: 1.67em;
    margin-bottom: 1.67em;
  }
  h6 {
    margin-top: 2.33em;
    margin-bottom: 2.33em;
  }
  hr {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
  }
  ol {
    margin-top: 1em;
    margin-bottom: 1em;
    padding-left: 20px;
  }
  p {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  ul {
    margin-top: 1em;
    margin-bottom: 1em;
    padding-left: 20px;
  }
`

const LearnArticle = () => {
  const isMobile = useMediaQuery(devices.tabport)
  const { id } = useParams()
  const { locale } = useLocale()
  const [article, setArticle] = useState()

  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/bnb-articles/${id}?populate=*`).then(
      res => res.json()
    )
  const {
    data: fetchedData,
    isLoading: loading,
    isError: error
  } = useFetchPage(`api/learnarticle${id}`, fetcher)

  const getLocalizedData = () => {
    let localizedData
    fetchedData?.localizations?.data?.map(item => {
      if (item?.attributes?.locale === locale) {
        localizedData = item?.attributes
      }
    })
    if (localizedData) {
      setArticle(localizedData)
    } else {
      setArticle(fetchedData)
    }
  }

  useEffect(() => {
    getLocalizedData()
  }, [locale, fetchedData])

  console.log(fetchedData)

  return (
    <QueryWrapper loading={loading} error={error}>
      <Wrapper>
        <ArticleHeader>
          <Flex gap="4rem" direction={isMobile ? 'column' : ''}>
            <div>
              <Text
                font="h3Bold"
                color="#000000"
                fontFamily="Roboto"
                fontSize="4rem"
              >
                {article?.title}
              </Text>
              <Flex
                justifyContent="flex-start"
                gap="3rem"
                alignItems="flex-start"
              >
                <Text font="body2Light" color="#000000">
                  {convertDate(article?.createdAt)}
                </Text>
                <Flex justifyContent="flex-start">
                  <TimeLapse fill="#000000" />
                  <Text font="body2Light" color="#000000">
                    {readingTime(article?.content)}
                  </Text>
                </Flex>
              </Flex>
            </div>
            <img
              alt="article-illustration"
              className="article-image"
              src={ArticleImage}
            />
          </Flex>
        </ArticleHeader>
        <ArticleContent>
          <div className="image-wrapper">
            <img
              alt="article-illustration"
              className="article-image"
              src={
                REACT_APP_STRAPI_API_URL +
                fetchedData?.image?.data?.attributes.url
              }
            />
          </div>
          <ReactMarkdown
            transformImageUri={uri =>
              uri
                .toString()
                .replace('http://localhost:1337', REACT_APP_STRAPI_API_URL)
            }
          >
            {article?.content}
          </ReactMarkdown>
        </ArticleContent>
      </Wrapper>
      <DomainSquare />
      <CallToAction />
    </QueryWrapper>
  )
}

export default LearnArticle
